import HeadingText from '@ancon/wildcat-ui/web/orderweb/HeadingText'
import moment from 'moment'
import useTranslation from 'next-translate/useTranslation'
import HandIcon from '@ancon/wildcat-ui/shared/icons/hand-click-outline.svg'
import BodyText from '@ancon/wildcat-ui/web/orderweb/BodyText'
import { useEffect, useState } from 'react'

import useAppSelector from '../../../../store/hooks/useAppSelector'
import { clientContextCustomerFirstNameSelector } from '../../../clientContext/store/clientContextSelectors'

import styles from './GreetingUser.module.scss'

export default function GreetingUser() {
  const { t } = useTranslation('outlets')

  const name = useAppSelector(clientContextCustomerFirstNameSelector)

  const [greeting, setGreeting] = useState<string | null>(null)

  useEffect(() => {
    // Compute the greeting after mount to avoid SSR hydration mismatches
    // when the server/build hour differs from the client hour (AI-25090)
    function getGreetingText() {
      const hour = moment().get('hour')

      if (hour < 12) {
        return t('greetingMessages.morning')
      }
      if (hour < 17) {
        return t('greetingMessages.afternoon')
      }
      return t('greetingMessages.evening')
    }

    setGreeting(getGreetingText())
  }, [t])

  const greetingMessage = greeting && name ? `${greeting}, ${name}` : greeting

  return (
    <div className={styles.container}>
      <HeadingText as="h2">{greetingMessage}</HeadingText>
      <div className={styles.row}>
        <HandIcon />
        <BodyText fontSize="1.6rem">{t('selectYourPreferredOutlet')}</BodyText>
      </div>
    </div>
  )
}
